module.exports = __webpack_public_path__ + "hero-1x-42b0b459888f282685b1304c6882a67c.webp";